'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});


function cbDisclaimer() {
    return {
        scope: {
            // Get disclaimer text from json. Default = null
            jsonUrl: '@',
            // Set the disclaimer you want to display from the array. Default = 0
            activeDisclaimer: '@',
            // Optional string variables
            textVars: '@'
        },
        restrict: 'E',
        bindToController: true,
        transclude: true,
        controllerAs: 'vm',
        controller: 'cbDisclaimerController',
        template: "<div data-ng-cloak class=\"cb-disclaimer\">\r\n    <p data-ng-bind=\"vm.disclaimer\"></p>\r\n    <p data-ng-transclude></p>\r\n    <p data-ng-if=\"vm.warning\">{{vm.warning}}</p>\r\n</div>\r\n"
    };
}

exports.default = cbDisclaimer;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/disclaimer/cb-disclaimer.directive.js
// module id = 884
// module chunks = 0